import * as React from "react";
import AccordionGroup from "@mui/joy/AccordionGroup";
import Accordion from "@mui/joy/Accordion";
import AccordionDetails from "@mui/joy/AccordionDetails";
import AccordionSummary from "@mui/joy/AccordionSummary";
import ListItem from "@mui/joy/ListItem";
import ListItemButton from "@mui/joy/ListItemButton";
import List from "@mui/joy/List";
import { domain, footerMsgData } from "../../data";
import { Box, Paper, Typography, Container } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Grid from "@mui/material/Grid";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TelegramIcon from "@mui/icons-material/Telegram";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";
import { MdCall } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import logo from "../../assets/vel-logo.jpg";
import { MdEmail } from "react-icons/md";
// import Container from "@mui/material";

export default function Footer() {
	const [expanded, setExpanded] = React.useState(null);

	const isDesktopOrLaptop = useMediaQuery({
		query: "(min-width: 1224px)",
	});
	const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
	const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" }); //1224px
	const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
	const isRetina = useMediaQuery({ query: "(min-resolution: 2dppx)" });

	if (isTabletOrMobile) {
		console.log("tab or mobile");
	} else if (isDesktopOrLaptop) {
		console.log("desktop or laptop");
	} else if (isBigScreen) {
		console.log("big screen");
	} else if (isPortrait) {
		console.log("portrait");
	} else if (isRetina) {
		console.log("retina");
	}

	const accordionItems = [
		{
			title: "About account",
			items: [
				"About Personal Account",
				"Beneficiaries & their testament",
				"Buy BTC",
				"Buy ETH",
				"Buy USDT",
			],
			url: "/en/register",
		},
		{
			title: "Platforms",
			items: [
				`${domain} MT5`,
				`${domain} cTrader`,
				`${domain} X`,
				`${domain} Trader`,
				`${domain} Bot`,
				`${domain} Go`,
				`SmartTrader`,
			],
			url: "/en/register",
		},
		// {
		// 	title: "Loan",
		// 	items: [
		// 		"Get Crypto Loan",
		// 		"Pay Crypto Loan",
		// 		"Check Crypto Loan Eligibility ",
		// 		"Increase Crypto Loan Amount",
		// 	],
		// },
		// {
		// 	title: "Earn",
		// 	items: [
		// 		"Airdrops",
		// 		"Affiliate Programs",
		// 		"ICO's/Token Sales",
		// 		"Give Crypto Loan & Earn Interest",
		// 		"NFT minting & Trading",
		// 	],
		// },
		{
			title: "Markets",
			items: [
				"Forex",
				"Derived Indices",
				"Stocks",
				"Stock Indices",
				"Commodities",
				"Cryptocurrencies",
				"ETFs",
			],
			url: "/en/register",
		},
		{
			title: "Trade",
			items: ["CFDs", "Options"],
			url: "/en/register",
		},
		{
			title: "Tools",
			items: [
				"Trading View",
				"MT5 Signals",
				"Trading Calculator",
				"Trading Central",
				"Economic Calendar",
				"Market Buzz",
			],
			url: "/en/register",
		},
		{
			title: "About Us",
			items: [
				"Who we are",
				"Why choose us",
				"Regulatory information",
				"Secure & responsible trading",
				"Careers",
				"Newsroom",
			],
			url: "/about",
		},
		{
			title: "Service",
			items: [
				"Secure % Reliable trading Platform",
				"Real-time market Data % Insights",
				"Advanced Trading Tools",
				"Educational Resources & Support",
			],
			url: "/service",
		},
		{
			title: "News & Analysis",
			items: ["Explore"],
			url: "/news",
		},

		{
			title: "Support and Help Center",
			items: ["Explore"],
			url: "/support",
		},
	];

	const socialIcons = [
		{
			name: "facebook",
			icon: <FacebookIcon sx={{ color: "white" }} />,
			id: 1,
		},
		{
			name: "LinkedInIcon",
			icon: <LinkedInIcon sx={{ color: "white" }} />,
			id: 2,
		},
		{
			name: "InstagramIcon",
			icon: <InstagramIcon sx={{ color: "white" }} />,
			id: 3,
		},
		{ name: "XIcon", icon: <XIcon sx={{ color: "white" }} />, id: 4 },
		{
			name: "YouTubeIcon ",
			icon: <YouTubeIcon sx={{ color: "white" }} />,
			id: 5,
		},
		{
			name: "facebook",
			icon: <TelegramIcon sx={{ color: "white" }} />,
			id: 6,
		},
	];

	const addressAndContact = [
		{
			info: "support@valorcrypt.com",
			icon: <MdEmail className="inline-block" />,
			country: "Email Us",
			id: 1,
		},
		{
			info: "+1 (520) 763-4388",
			icon: <MdCall className="inline-block" />,
			country: "Call Us",
			id: 2,
		},
		{
			info: "14 Scotsburn Road, Glasgow, Scotland, G21 3HX, United Kingdom",
			icon: <FaLocationDot className="inline-block" />,
			country: "United Kingdom",
			id: 3,
		},
		// {
		// 	info: "13 Maple Avenue, Springfield, IL 62704, United States",
		// 	icon: <FaLocationDot className="inline-block" />,
		// 	country: "USA",
		// 	id: 4,
		// },
		// {
		// 	info: "789 Pine Street, Toronto, ON M5V 2N8, Canada",
		// 	icon: <FaLocationDot className="inline-block" />,
		// 	country: "Canada",
		// 	id: 5,
		// },
	];

	const handleAccordionChange = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : null);
	};

	const smallScreenView = (
		<AccordionGroup sx={{ minWidth: "100%", px: "1rem" }}>
			{accordionItems.map((accordion, index) => (
				<Accordion
					key={accordion.title}
					expanded={expanded === accordion.title}
					onChange={handleAccordionChange(accordion.title)}>
					<AccordionSummary>
						<span className="text-gray-500">{accordion.title}</span>
					</AccordionSummary>
					<AccordionDetails>
						<List>
							{accordion.items.map((item, itemIndex) => (
								<ListItem key={`${accordion.title}-${itemIndex}`}>
									<ListItemButton>
										{" "}
										<Link className="text-white" to={accordion.url}>
											- {item}
										</Link>
									</ListItemButton>
								</ListItem>
							))}
						</List>
					</AccordionDetails>
				</Accordion>
			))}
		</AccordionGroup>
	);

	const largeScreenView = (
		<Box sx={{ width: "85%", mx: "auto" }}>
			<ul className=" mx-auto    grid  grid-cols-5  gap-[1.3rem]  ">
				{accordionItems.map((dt) => (
					<li>
						<h6 className="text-white">{dt.title}</h6>
						<hr className="my-[0.7rem]" />
						<div className="flex  flex-col">
							{dt.items.map((sub_dt) => (
								<Link
									to="/en/register"
									className="text-white  my-[0.3rem]  hover:underline  hover:underline-offset-2">
									{sub_dt}
								</Link>
							))}
						</div>
					</li>
				))}
			</ul>
		</Box>
	);

	return (
		<footer className="  w-full  bg-black text-white  border-t-2  border-t-gray-400  rounded-t-[2rem]   mt-[2rem]  relative bottom-0">
			{/* contact info */}
			<Box sx={{ pt: "1rem" }}>
				<img
					src={logo}
					alt=""
					className="h-[8rem] w-[8rem]   m-[1rem] rounded-[1rem]"
				/>
				{/* <ul className="pl-[1rem]   mt-[1rem] flex  flex-col gap-[0.2rem]">
					<li>
						<span className="font-bold">
							{" "}
							<MdEmail className="inline-block" /> Email :
						</span>{" "}
						<span className="font-serif  tracking-wide">
							{" "}
							Info@globalextrade.online
						</span>
					</li>
					<li>
						<span className="font-bold">
							{" "}
							<MdCall className="inline-block" /> UK :
						</span>{" "}
						<span className="font-serif  tracking-wide"> +447441905174</span>
					</li>
					<li>
						{" "}
						<span className="font-bold">
							{" "}
							<MdCall className="inline-block" /> Canada :
						</span>{" "}
						<span className="font-serif  tracking-wide">
							+1{"("}438{")"}266-1222
						</span>
					</li>
					<li>
						{" "}
						<span className="font-bold">
							{" "}
							<MdCall className="inline-block" /> USA :
						</span>
						<span className="font-serif  tracking-wide">
							{" "}
							+1{"("}909{")"}505-3959
						</span>
					</li>
				</ul> */}
			</Box>
			<Box sx={{ pt: "1rem" }}>
				<ul className="pl-[1rem]    mt-[1rem] flex  flex-col gap-[0.2rem]">
					{addressAndContact.map((dt) => (
						<li
							key={dt.id}
							className={`${
								dt.id === 1 ? "underline underline-offset-4" : ""
							}`}>
							<span className="font-bold">
								{" "}
								{dt.icon} {dt.country}:
								{/* <FaLocationDot className="inline-block" /> UK : */}
							</span>{" "}
							<span className="font-serif  tracking-wide  "> {dt.info}</span>
						</li>
					))}

					{/* <li>
						<span className="font-bold">
							{" "}
							<FaLocationDot className="inline-block" /> UK :
						</span>{" "}
						<span className="font-serif  tracking-wide  ">
							{" "}
							4 Bell Yard, England 33, WC2A
						</span>
					</li>
					<li>
						{" "}
						<span className="font-bold">
							{" "}
							<FaLocationDot className="inline-block" /> USA :
						</span>{" "}
						<span className="font-serif  tracking-wide">
							39 TEC ST Hicksville, NY 11801
						</span>
					</li> */}
					{/* <li>
						{" "}
						<span className="font-bold">
							{" "}
							<MdCall className="inline-block" /> USA :
						</span>
						<span className="font-serif  tracking-wide">
							{" "}
							+1{"("}909{")"}505-3959
						</span>
					</li> */}
				</ul>
			</Box>
			<Box sx={{ flexGrow: 1 }}>
				<Grid
					container
					spacing={2}
					minHeight={160}
					sx={{ px: "2.2rem", mx: "auto" }}>
					{socialIcons.map((dt) => (
						<Grid
							key={dt.id}
							display="flex"
							justifyContent="center"
							alignItems="center"
							size="grow">
							<Avatar
								sx={{ bgcolor: "black", border: 2, borderColor: "white" }}>
								{dt.icon}
							</Avatar>
						</Grid>
					))}
				</Grid>
			</Box>
			{isTabletOrMobile ? smallScreenView : largeScreenView}
			{/* <Box
				sx={{
					px: "1.5rem",
					my: "1.5rem",
					gap: "0.6rem",
				}}>
				{footerMsgData.map((dt) => (
					<Typography sx={{ my: "0.4rem", fontSize: "0.9rem" }}>
						{domain} &copy; 2025
					</Typography>
				))}
			</Box> */}
			{/* <Paper
				elevation={24}
				sx={{
					borderStyle: "#CED2C6",
					background: "#CED2C6",
					width: "95%",
					p: "0.7rem",
					mx: "auto",
					my: "1rem",
				}}> */}
			{/* <Typography sx={{ fontSize: "0.9rem" }}>
					The products offered on our website are complex derivative products
					that carry a significant risk of potential loss. CFDs are complex
					instruments with a high risk of losing money rapidly due to leverage.
					You should consider whether you understand how these products work and
					whether you can afford to take the high risk of losing your money.
			// 	</Typography> */}
			{/* <Box
				sx={{
					px: "1.5rem",
					my: "1.5rem",
					gap: "0.6rem",
				}}>
				<Typography
					sx={{
						my: "0.4rem",
						marginX: "auto",
						fontSize: "0.9rem",
					}}></Typography>
			</Box> */}

			<p className="w-[93%]  pl-[2rem]  my-[1rem]">
				Risk Disclaimer: The range of financial instruments available through
				the Vertex Capital Hub platform, including digital assets, CFDs, and
				other advanced derivatives, present valuable opportunities for
				experienced investors. While these instruments involve inherent risks,
				understanding and managing them responsibly can help you make informed
				trading decisions. We encourage traders to invest only what they can
				comfortably afford to risk and to avoid trading with borrowed funds.
				Prior to engaging with the markets, take the time to deepen your
				understanding of the associated risks and adopt secure, responsible
				trading practices to support your financial objectives.
			</p>
			<p className="text-center text-[0.8rem]  pb-[1rem] font-serif mt-[3rem] tracking-wide">
				{domain} &copy; 2025
			</p>
		</footer>
	);
}
